import { render, createElement } from '@wordpress/element';
import { ChartBuilderWrapper } from './Charts/Component';
import resultsMarkup from './results-markup';
import resultsClusterMarkup from './results-markup-cluster';
import './index.scss';

console.log('test');
const lnh = {
	cbsaData: '',
	clusterData: '',
	// default config for charts
	config: {
		layout: {
			type: 'bar',
			orientation: 'horizontal',
			width: 640,
			height: 400,
			padding: [0, 0, 0, 0],
		},
		xAxis: {
			domain: null,
		},
		yAxis: {
			padding: 40,
			domain: null,
			domainPadding: 20,
		},
		data: {
			x: 'x',
			y: 'y',
			sortKey: 'y',
			sortOrder: 'ascending',
		},
		legend: {
			show: true,
			legendPosition: 'top',
		},
		bar: {
			width: 24,
			barToSpaceRatio: 1.1,
		},
		colors: ['#733D47', '#BD7C87', '#D1A8AF', '#E8D3D7'],
		labels: {
			color: 'black',
			fontWeight: 200,
			fontSize: 10,
			labelPositionDX: -27,
			labelPositionDY: null,
			pieLabelRadius: 60,
			toFixedDecimal: 0,
		},
	},
	apiInit: () => {
		jQuery
			.ajax({
				// url:
				//   "https://pewresearch-org-preprod.go-vip.co/journalism/wp-json/prc-api/v2/interactive",
				url: `${siteURL}/wp-json/prc-api/v2/interactive`,
				type: 'GET',
				data: {
					slug: 'local-news-habits',
				},
			})
			.done((data, textStatus, jqXHR) => {
				console.log(`Text: ${textStatus}`);
				console.log(`HTTP Request Succeeded: ${jqXHR.status}`);
				lnh.cbsaData = data.cbsa;
				lnh.clusterData = data.cluster;
				lnh.populateSearch(lnh.cbsaData);
				document
					.getElementById('lnh-search-bar')
					.classList.remove('loading');
			})
			.fail((jqXHR, textStatus, errorThrown) => {
				console.log('HTTP Request Failed');
			})
			.always(() => {
				/* ... */
			});
		// const cbsaRef = interactivesDB.database().ref("local-news-habits");
		// cbsaRef.once("value").then(function(snapshot) {
		//   var data = snapshot.val();
		//   lnh.cbsaData = data.cbsa;
		//   lnh.clusterData = data.cluster;
		//   lnh.populateSearch(lnh.cbsaData);
		//   document.getElementById("lnh-search-bar").classList.remove("loading");
		// });
	},
	populateSearch: (data) => {
		const searchContent = [];

		// push names and cbsa codes to an array of objects
		Object.keys(data).forEach((key) => {
			searchContent.push({
				// '--' marks in code need to be replaced with em dash
				title: data[key].full_name.replace(/--/g, '—'),
				cbsaCode: key,
			});
		});

		// use this array as the source for search bar
		jQuery('.ui.search').search({
			source: searchContent,
			searchFields: ['title'],
			fullTextSearch: 'exact',
			error: {
				noResults:
					'Your search returned no results. Try searching a larger metro area nearby.',
			},
			onSelect: (result) => {
				lnh.filterResults(result);
				history.pushState(
					null,
					null,
					`${siteURL}/feature/local-news-habits/${result.cbsaCode}/`
				);
			},
		});

		// if there is a url string passed thru, prepopulate the search bar with that area, return selected
		if (prcURLVars.cbsa && !isNaN(prcURLVars.cbsa)) {
			jQuery('.ui.search').search(
				'set value',
				lnh.cbsaData[prcURLVars.cbsa].full_name.replace(/--/g, '—')
			);
			const $result = jQuery('.ui.search').search(
				'get result',
				lnh.cbsaData[prcURLVars.cbsa].full_name.replace(/--/g, '—')
			);
			lnh.filterResults($result);
		}

		// clear button
		document.getElementById('clear-input').onclick = () => {
			jQuery('.ui.search').search('set value', '');
		};
	},
	filterResults: (result) => {
		const selectedCBSA = lnh.cbsaData[result.cbsaCode];

		// if the CBSA has an associated cluster id, return a cluster
		selectedCBSA.CBSA_cluster == 0
			? lnh.renderAsCBSA(selectedCBSA)
			: lnh.renderAsCluster(selectedCBSA);
	},
	renderAsCBSA: (selectedCBSA) => {
		document.getElementById('lnh-results').innerHTML =
			resultsMarkup(selectedCBSA);
		lnh.prepCharts(selectedCBSA);

		// TODO: maybe in the future, but these seem somewhat redundant with some of the stuff I've got going on in the subsequent function
		jQuery('html, body').animate(
			{
				scrollTop: jQuery('#results-sections').offset().top - 100,
			},
			750
		);
		jQuery('.sticky__search').sticky();
		jQuery('.sticky__nav').sticky({
			context: '#primary',
			offset: 100,
			debug: false,
		});
		jQuery('.nav-element').on('click', function () {
			const $section = jQuery(this).data('section');
			jQuery('html, body').animate(
				{
					scrollTop: jQuery(`#${$section}`).offset().top - 75,
				},
				750
			);
		});
	},
	renderAsCluster: (selectedCBSA) => {
		document.getElementById('lnh-results').innerHTML = resultsClusterMarkup(
			selectedCBSA,
			lnh.clusterData[selectedCBSA.CBSA_cluster]
		);
		setTimeout(() => {
			document.getElementById('no-results').classList.add('flash');
		}, 500);
		setTimeout(() => {
			document.getElementById('no-results').classList.remove('flash');
		}, 1500);
		lnh.prepCharts(lnh.clusterData[selectedCBSA.CBSA_cluster]);
		const clusterBtn = document.getElementById('show-cluster');
		clusterBtn.addEventListener('click', slideToResults, false);
		clusterBtn.addEventListener('touchend', slideToResults, false);
		function slideToResults() {
			document
				.querySelector('.results-container')
				.classList.remove('no-show');
			jQuery('html, body').animate(
				{
					scrollTop: jQuery('#results-sections').offset().top - 100,
				},
				750
			);
			setTimeout(() => {
				jQuery('.sticky__search').sticky();
				jQuery('.sticky__nav').sticky({
					context: '#primary',
					offset: 100,
					debug: false,
				});
			}, 1500);
		}

		jQuery('html, body').animate(
			{
				scrollTop: jQuery('.search-container').offset().top - 100,
			},
			750
		);
		jQuery('.nav-element').on('click', function () {
			const $section = jQuery(this).data('section');
			jQuery('html, body').animate(
				{
					scrollTop: jQuery(`#${$section}`).offset().top - 75,
				},
				750
			);
		});
	},
	prepCharts: (cbsa) => {
		// format data according to desired output
		const LOCAL_PREFER = lnh.formattedData(cbsa.LOCAL_PREFER.answers);
		if (cbsa.MAIN_SOURCE) {
			var MAIN_SOURCE = lnh.formattedDataMainSource(
				cbsa.MAIN_SOURCE.answers,
				'main'
			);
			var MAIN_SOURCE_OTHER = lnh.formattedDataMainSource(
				cbsa.MAIN_SOURCE.answers,
				'other'
			);
		}
		const PROVIDER = lnh.formattedBatteryToStack(
			cbsa.PROVIDER.battery_answers
		);
		const LOCNEWSWEB = lnh.formattedBatteryToStack(
			cbsa.LOCNEWSWEB.battery_answers
		);
		const LOCAL_DEVICE = lnh.formattedData(
			cbsa.LOCAL_DEVICE.answers,
			'pie'
		);
		const TOPICIMPORT = lnh.formattedBatteryToStack(
			cbsa.TOPICIMPORT.battery_answers
		);
		const TOPICINFO = lnh.formattedBatteryToBar(
			cbsa.TOPICINFO.battery_answers
		);
		const JOBVALUES = lnh.formattedBatteryToBar(
			cbsa.JOBVALUES.battery_answers
		);
		const LOCALMEDIA_JOB = lnh.formattedBatteryToSingleStack(
			cbsa.LOCALMEDIA_JOB.answers
		);
		const MAIN_CONF = lnh.formattedBatteryToSingleStack(
			cbsa.MAIN_CONF.answers
		);

		// render charts with config alterations
		lnh.renderChart(
			LOCAL_PREFER,
			{
				...lnh.config,
				layout: {
					type: 'bar',
					orientation: 'horizontal',
					width: 640,
					height: LOCAL_PREFER.length * 32,
				},
				xAxis: {
					domain: [0, 100],
				},
				yAxis: {
					padding: 135,
					domain: null,
					domainPadding: 20,
				},
			},
			'LOCAL_PREFER'
		);
		// if the selected CBSA has this "MAIN_SOURCE" data, render charts, otherwise skip it
		if (cbsa.MAIN_SOURCE) {
			lnh.renderChart(
				MAIN_SOURCE,
				{
					...lnh.config,
					layout: {
						type: 'bar',
						orientation: 'horizontal',
						width: 640,
						height: MAIN_SOURCE.length * 32,
					},
					xAxis: {
						domain: [0, 100],
					},
					yAxis: {
						padding: 200,
						domain: null,
						domainPadding: 20,
					},
					data: {
						x: 'x',
						y: 'y',
						sortKey: 'noSort',
						sortOrder: 'noSort',
					},
				},
				'MAIN_SOURCE'
			);
			lnh.renderChart(
				MAIN_SOURCE_OTHER,
				{
					...lnh.config,
					layout: {
						type: 'bar',
						orientation: 'horizontal',
						width: 640,
						height: MAIN_SOURCE_OTHER.length * 32 + 30,
					},
					xAxis: {
						domain: [0, 100],
					},
					yAxis: {
						padding: 200,
						domain: null,
						domainPadding: [20, 60],
					},
					data: {
						x: 'x',
						y: 'y',
						sortKey: 'noSort',
						sortOrder: 'noSort',
					},
					colors: ['#E8D3D7'],
				},
				'MAIN_SOURCE_OTHER'
			);
		}
		lnh.renderChart(
			PROVIDER,
			{
				...lnh.config,
				layout: {
					type: 'stacked-bar',
					height: 325,
					width: 640,
					padding: [0, 0, 0, 0],
				},
				yAxis: {
					padding: 135,
					domain: null,
					domainPadding: 20,
				},
				data: {
					x: 'x',
					y: 'y',
					sortKey: 'y',
					sortOrder: 'descending',
				},
				labels: {
					color: 'black',
					fontWeight: 200,
					fontSize: 10,
					labelPositionDX: -24,
					labelPositionDY: null,
					pieLabelRadius: 60,
					toFixedDecimal: 0,
				},
			},
			'PROVIDER'
		);
		lnh.renderChart(
			LOCNEWSWEB,
			{
				...lnh.config,
				layout: {
					type: 'stacked-bar',
					height: 80,
					width: 640,
					padding: [0, 0, 0, 0],
				},
				yAxis: {
					padding: 135,
					domain: null,
					domainPadding: 20,
				},
				labels: {
					color: 'black',
					fontWeight: 200,
					fontSize: 10,
					labelPositionDX: -28,
					labelPositionDY: null,
					pieLabelRadius: 60,
					toFixedDecimal: 0,
				},
			},
			'LOCNEWSWEB'
		);
		lnh.renderChart(
			LOCAL_DEVICE,
			{
				...lnh.config,
				layout: {
					type: 'pie',
					width: 200,
					height: 200,
					padding: [0, 0, 0, 0],
				},
				labels: {
					color: 'black',
					fontWeight: 200,
					fontSize: 10,
					labelPositionDX: -20,
					labelPositionDY: null,
					pieLabelRadius: 55,
					toFixedDecimal: 0,
				},
			},
			'LOCAL_DEVICE'
		);
		lnh.renderChart(
			TOPICIMPORT,
			{
				...lnh.config,
				layout: {
					type: 'stacked-bar',
					height: 400,
					width: 640,
					padding: [0, 0, 0, 0],
				},
				yAxis: {
					padding: 140,
					domain: null,
					domainPadding: 20,
				},
				labels: {
					color: 'black',
					fontWeight: 200,
					fontSize: 10,
					labelPositionDX: -25,
					labelPositionDY: null,
					pieLabelRadius: 60,
					toFixedDecimal: 0,
				},
			},
			'TOPICIMPORT'
		);
		lnh.renderChart(
			TOPICINFO,
			{
				...lnh.config,
				layout: {
					type: 'bar',
					orientation: 'horizontal',
					width: 640,
					height: TOPICINFO.length * 32,
				},
				xAxis: {
					domain: [0, 100],
				},
				yAxis: {
					padding: 140,
					domain: null,
					domainPadding: 20,
				},
				colors: ['#D1A730'],
				labels: {
					color: 'black',
					fontWeight: 200,
					fontSize: 10,
					labelPositionDX: -33,
					labelPositionDY: null,
					pieLabelRadius: 60,
					toFixedDecimal: 0,
				},
			},
			'TOPICINFO'
		);
		lnh.renderChart(
			JOBVALUES,
			{
				...lnh.config,
				layout: {
					type: 'bar',
					orientation: 'horizontal',
					width: 640,
					height: JOBVALUES.length * 32,
				},
				xAxis: {
					domain: [0, 100],
				},
				yAxis: {
					padding: 240,
					domain: null,
					domainPadding: 20,
				},
				labels: {
					color: 'black',
					fontWeight: 200,
					fontSize: 10,
					labelPositionDX: -33,
					labelPositionDY: null,
					pieLabelRadius: 60,
					toFixedDecimal: 0,
				},
			},
			'JOBVALUES'
		);
		lnh.renderChart(
			LOCALMEDIA_JOB,
			{
				...lnh.config,
				layout: {
					type: 'single-stacked-bar',
					height: 50,
					width: 640,
					padding: [0, 0, 0, 0],
				},
				labels: {
					color: 'black',
					fontWeight: 200,
					fontSize: 10,
					labelPositionDX: -28,
					labelPositionDY: null,
					pieLabelRadius: 60,
					toFixedDecimal: 0,
				},
				colors: ['#733D47', '#BD7C87', '#E4CB83', '#D1A730'],
			},
			'LOCALMEDIA_JOB'
		);
		lnh.renderChart(
			MAIN_CONF,
			{
				...lnh.config,
				layout: {
					type: 'single-stacked-bar',
					height: 50,
					width: 640,
					padding: [0, 0, 0, 0],
				},
				labels: {
					color: 'black',
					fontWeight: 200,
					fontSize: 10,
					labelPositionDX: -28,
					labelPositionDY: null,
					pieLabelRadius: 60,
					toFixedDecimal: 0,
				},
				colors: ['#733D47', '#BD7C87', '#E4CB83', '#D1A730'],
			},
			'MAIN_CONF'
		);
	},
	renderChart: (data, config, target) => {
		// hook into the chart builder library
		render(
			createElement(ChartBuilderWrapper, {
				data,
				config,
			}),
			document.getElementById(target)
		);
	},
	formattedData: (data, type) => {
		const formattedArr = [];

		for (let i = 0; i < data.options.length; i++) {
			formattedArr.push({
				x: data.options[i],
				y: data.values[i],
			});
		}
		if (type !== 'pie') {
			for (const item of formattedArr) {
				item.label = item.y.toFixed(0);
			}
		} else {
			for (const item of formattedArr) {
				// TODO: this feels a little hacky but will work for this project. We know that the first sliver of the pie chart is gonna be a dark purple, so we add a fill key and set it to white by default.
				item.fill = item === formattedArr[0] ? 'white' : 'black';
				item.label = `${item.y.toFixed(0)}%`;
			}
		}

		return formattedArr;
	},
	formattedDataMainSource: (data, type) => {
		// this data actually needs to be split into two different arrays (ugh)
		const formattedArr = [];

		for (let i = 0; i < data.options.length; i++) {
			if (type !== 'main') {
				if (
					data.options[i] === 'None/Refused' ||
					data.options[i] === 'Other' ||
					data.options[i] === 'National news source'
				) {
					formattedArr.push({
						x: data.options[i],
						y: data.values[i],
						label: data.values[i].toFixed(0),
					});
				}
			} else if (
				data.options[i] !== 'None/Refused' &&
				data.options[i] !== 'Other' &&
				data.options[i] !== 'National news source'
			) {
				formattedArr.push({
					x: data.options[i],
					y: data.values[i],
					label: data.values[i].toFixed(0),
				});
			}
		}
		// data needs to be reversed to render in correct order
		return formattedArr.reverse();
	},
	formattedBatteryToBar: (data) => {
		// this specific data for some reason isn't formatted like the rest :(
		const formattedArr = [];

		for (let i = 0; i < data.length; i++) {
			formattedArr.push({
				x: data[i].text,
				y: data[i].values[0],
			});
		}
		// this is actually a very cool function that I'm gonna leave here in case we decide to revert to showing % labels for top value
		// let highestVal = formattedArr.reduce(
		//   (max, p) => (p.y > max ? p.y : max),
		//   formattedArr[0].y
		// );
		for (const item of formattedArr) {
			// if (item.y === highestVal) {
			//   item.label = item.y.toFixed(0) + "%";
			// } else {
			item.label = item.y.toFixed(0);
			// }
		}
		return formattedArr;
	},
	formattedBatteryToStack: (data) => {
		const formattedArr = [];

		for (let i = 0; i < data[0].options.length; i++) {
			const newArr = [];
			for (let j = 0; j < data.length; j++) {
				newArr.push({
					x: data[j].text,
					y: data[j].values[i],
					label: data[j].values[i].toFixed(0),
				});
			}
			formattedArr.push(newArr.reverse());
		}

		return formattedArr;
	},
	formattedBatteryToSingleStack: (data) => {
		const formattedArr = [];

		for (let i = 0; i < data.options.length; i++) {
			const newArr = [];
			newArr.push({
				x: ' ',
				y: data.values[i],
				label: data.values[i].toFixed(0),
			});
			formattedArr.push(newArr);
		}

		return formattedArr;
	},
	init: () => {
		const landingPage = `
    <div class="landing-page">
        <p>Every day, Americans turn to their local news media to learn about the news in their communities. But how they get the news, which topics they prioritize and how they evaluate their local outlets can vary from one community to the next. To better understand these differences, <a href="https://www.journalism.org/2019/03/26/for-local-news-americans-embrace-digital-but-still-want-strong-community-connection" target="_blank">Pew Research Center surveyed about 35,000 U.S. adults</a>, allowing for local news profiles of individual communities.</p>
        <p>Local results are available for 99 large CBSAs, which are geographic areas that include at least one urban center (<a href="https://www.journalism.org/2019/03/26/local-news-methodology/" target="_blank">see the Methodology</a>). Results for smaller CBSAs are grouped together based on their similarity across factors such as income, race and ethnicity, and voter turnout.</p>
        <p><strong>To see a profile of your area, begin typing the name of your city in the search bar below.</strong></p>
        <div class="search-container">
            <div class="ui search sticky sticky__search fluid loading" id="lnh-search-bar">
              <div class="input-container">
                  <div class="ui icon input">
                      <input class="prompt" type="text" placeholder="Search ...">
                  </div>
                  <div class="icon-container" id="clear-input">
                      <i class="times circle icon"></i>
                  </div>
                </div>
                <div class="results"></div>
            </div>
        </div>
    </div>
    <div id="lnh-results"></div>
    `;
		document.getElementById('js-local-news-habits').innerHTML = landingPage;
		lnh.apiInit();
	},
};

document.addEventListener('DOMContentLoaded', (event) => {
	lnh.init();
});
